// Module
var code = `<div class="card editor-container"> <div class="card-header sticky-top bg-white"></div> <div class="card-body p-0"></div> <div class="card-footer p-1"></div> </div>`;
// Exports
export default code;